export default __webpack_public_path__ + "static/media/digital-india-nfo-banner.4eeaaee7.png";